import gql from "graphql-tag";
import {
  MEETING_FIELDS,
  METRIC_FIELDS,
  OBJECTIVE_FIELDS,
  ROCK_FIELDS,
  SUCCESS_CRITERIA_FIELDS,
  TODO_FIELDS,
  WEEKLY_TARGET_FIELDS,
} from "./fragments";

export const GET_OBJECTIVES = gql`
  ${OBJECTIVE_FIELDS}
  query GetObjectives(
    $organization: ID!
    $planId: ID
    $sharedPlanId: ID
    $category: String
    $objectives: [ID!]
    $users: [ID!]
    $statuses: [String]
  ) {
    objectives(
      organization: $organization
      corpPlan: $planId
      sharedPlanId: $sharedPlanId
      category: $category
      objectives: $objectives
      users: $users
      statuses: $statuses
    ) {
      ...ObjectiveFields
    }
  }
`;

export const GET_QUARTER_ROCKS = gql`
  ${ROCK_FIELDS}
  query GetQuarterRocks($organization: ID!, $sharedPlanId: ID, $oneYearCorpPlan: ID) {
    rocks(organization: $organization, sharedPlanId: $sharedPlanId, oneYearCorpPlan: $oneYearCorpPlan) {
      ...RockFields
      objective {
        id
        value
      }
    }
  }
`;

export const GET_ROCKS = gql`
  ${ROCK_FIELDS}
  query GetRocks($organization: ID!, $sharedPlanId: ID, $objective: ID) {
    rocks(organization: $organization, sharedPlanId: $sharedPlanId, objective: $objective) {
      ...RockFields
      objective {
        id
        value
      }
    }
  }
`;

export const GET_METRICS = gql`
  ${METRIC_FIELDS}
  query GetMetrics($organization: ID!, $planId: ID!, $sharedPlanId: ID, $users: [ID!], $category: String) {
    metrics(organization: $organization, corpPlan: $planId, sharedPlanId: $sharedPlanId, users: $users, category: $category) {
      ...MetricFields
    }
  }
`;

export const GET_WEEKLY_TARGETS = gql`
  ${WEEKLY_TARGET_FIELDS}
  query GetWeeklyTargets($organization: ID!, $sharedPlanId: ID, $oneYearCorpPlan: ID, $user: ID, $users: [ID!]) {
    weeklyTargets(organization: $organization, sharedPlanId: $sharedPlanId, oneYearCorpPlan: $oneYearCorpPlan, user: $user, users: $users) {
      ...WeeklyTargetFields
    }
  }
`;

export const GET_TODOS = gql`
  ${TODO_FIELDS}
  query GetTodos(
    $organization: ID!
    $sharedPlanId: ID
    $category: String!
    $oneYearCorpPlan: ID
    $page: Int
    $rowsPerPage: Int
    $searchTerm: String
    $sortBy: String
    $sortDir: String
    $done: Boolean
  ) {
    ...TodoFields
  }
`;

export const GET_ONE_YEAR_METRICS = gql`
  query MetricsDialog_GetOneYearMetrics($organization: ID!, $sharedPlanId: ID) {
    metrics(organization: $organization, category: "quarter", sharedPlanId: $sharedPlanId) {
      id
      value
      number
      measurables {
        value
        reference {
          id
        }
      }
      plan {
        id
        departmentName
        sharedPlanId
        year
        plan {
          id
          year
        }
        color
        shortName
      }
    }
  }
`;

export const GET_THREE_YEAR_METRICS = gql`
  query MetricsDialog_GetThreeYearMetric($organization: ID!, $sharedPlanId: ID) {
    metrics(organization: $organization, category: "year", sharedPlanId: $sharedPlanId) {
      id
      value
      number
      category
      measurables {
        value
        notes {
          id
        }
        reference {
          id
          calculateTotal
          measurables {
            value
          }
        }
        distribution
      }
      plan {
        id
        departmentName
        sharedPlanId
        year
        plan {
          id
          year
        }
        color
        shortName
      }
    }
  }
`;

export const GET_ONE_YEAR_PLAN = gql`
  query MetricsDialog_GetOneYearPlan($organization: ID!, $sharedPlanId: ID) {
    plan(organization: $organization, sharedPlanId: $sharedPlanId, category: "1 year", closed: false) {
      id
    }
  }
`;

export const GET_MEETINGS = gql`
  ${MEETING_FIELDS}
  query Meetings_GetMeetings($organization: ID!, $sharedPlanId: ID, $meetingUser: ID, $startDate: String, $endDate: String) {
    meetings(
      organization: $organization
      sharedPlanId: $sharedPlanId
      meetingUser: $meetingUser
      startDate: $startDate
      endDate: $endDate
    ) {
      ...MeetingFields
    }
  }
`;

export const GET_SUCCESS_CRITERIAS = gql`
  ${SUCCESS_CRITERIA_FIELDS}
  query ($organization: ID!, $sharedPlanId: ID, $users: [ID], $startDate: String, $endDate: String) {
    successCriterias(organization: $organization, sharedPlanId: $sharedPlanId, users: $users, startDate: $startDate, endDate: $endDate) {
      ...SuccessCriteriaFields
      rock {
        plan {
          departmentName
          shortName
          color
        }
      }
    }
  }
`;

export const GET_NOTES = gql`
  query ($organization: ID!, $corpPlan: ID, $sharedPlanId: ID, $pinnedFirst: Boolean, $offset: Int, $limit: Int, $search: String) {
    notes(
      organization: $organization
      corpPlan: $corpPlan
      sharedPlanId: $sharedPlanId
      pinnedFirst: $pinnedFirst
      offset: $offset
      limit: $limit
      search: $search
    ) {
      notes {
        id
        text
        filename
        url
        type
        pinned
        createdAt
        updatedAt
        user {
          id
          profilePicture
          name {
            first
            last
          }
        }
        reference {
          id
          ids
          type
          context
        }
        referenceEntity {
          ... on Organization {
            id
            name
          }
          ... on Plan {
            id
            departmentName
            category
          }
          ... on Project {
            id
            value
          }
          ... on Todo {
            id: _id
            value
          }
          ... on Metric {
            id
            value
          }
          ... on Objective {
            id
            value
          }
          ... on Rock {
            id
            value
          }
          ... on SuccessCriteria {
            id
            value
          }
          ... on WeeklyTarget {
            id: _id
            value
          }
          ... on Meeting {
            id
            title
          }
        }
      }
      pageInfo {
        totalCount
        hasMore
        currentPage
        totalPages
      }
    }
  }
`;
